import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const communicationsStatusPageConfigurationRoute: InvariantJiraRoute = {
	name: 'communications-status-page-configuration',
	path: '/jira/communications/status-page/configuration/:pageId',
};
